import { Users, Trophy, BadgeCheck, TrendingUp } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';
import useCountUp from '../hooks/useCountUp';

function ProofStat({ icon, count, suffix, label }) {
  const [ref, isVisible] = useScrollReveal(0.3);
  const value = useCountUp(count, isVisible);
  return (
    <div className="proof-stat" ref={ref}>
      <div className="proof-icon">{icon}</div>
      <div className="proof-num">{value}{suffix}</div>
      <div className="proof-label">{label}</div>
    </div>
  );
}

export default function SocialProof() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="social-proof">
      <div className={`social-proof-inner reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <ProofStat icon={<Users size={32} />} count={12500} suffix="+" label="Membres actifs" />
        <ProofStat icon={<Trophy size={32} />} count={850} suffix="+" label="Pronostiqueurs" />
        <ProofStat icon={<BadgeCheck size={32} />} count={94} suffix="%" label="Taux de satisfaction" />
        <ProofStat icon={<TrendingUp size={32} />} count={45000} suffix="+" label="Coupons publiés" />
      </div>
    </section>
  );
}
